import { type OrderProduct } from '@repo/domain';

import { type PaymentResultLocationState } from '@features/reservation/types';

const ORDER_PRODUCTS: OrderProduct[] = ['parkingSpotRental', 'parkingSpotRentalExtension', 'balanceTopUp'];

const DEFAULT_PAYMENT_RESULT: PaymentResultLocationState = { product: 'parkingSpotRental' };

const isOrderProduct = (value: unknown): value is OrderProduct =>
  typeof value === 'string' && (ORDER_PRODUCTS as string[]).includes(value);

/** Read what the payment result pages show from router state; a reservation when absent. */
export function readPaymentResult(locationState: unknown): PaymentResultLocationState {
  if (!locationState || typeof locationState !== 'object') return DEFAULT_PAYMENT_RESULT;
  const { product, returnTo } = locationState as Partial<PaymentResultLocationState>;
  if (!isOrderProduct(product)) return DEFAULT_PAYMENT_RESULT;
  const hasReturnTo = !!returnTo && typeof returnTo === 'object' && typeof returnTo.pathname === 'string';
  return { product, returnTo: hasReturnTo ? returnTo : undefined };
}
